export { EquipmentDetailRoute } from "..";

/** @deprecated use EquipmentDetailRoute instead */
export const EQUIPMENT_DETAIL_FALLBACK_PAGE_TITLE =
  "Equipment Detail:equipmentId";

/** @deprecated use EquipmentDetailRoute instead */
export const linkToEquipmentDetail = (equipmentId = ":equipmentId") =>
  `/app/organization/equipment/${equipmentId}/detail`;

/** @deprecated use EquipmentDetailRoute instead */
export const EQUIPMENT_DETAIL_BREADCRUMB = {
  title: EQUIPMENT_DETAIL_FALLBACK_PAGE_TITLE,
  path: linkToEquipmentDetail,
};
